import { render, staticRenderFns } from "./StatusChange.vue?vue&type=template&id=f0501fc2&"
import script from "./StatusChange.vue?vue&type=script&lang=ts&"
export * from "./StatusChange.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports